var _g, _g2, _g3, _g4, _g5, _g6, _g7, _rect, _text, _text2, _g8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _line, _line2, _line3, _line4, _text3, _text4, _rect2, _text5, _text6, _rect3, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _rect4, _line5, _rect5, _g17, _rect6, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _rect7, _g18, _rect8, _text7, _text8, _rect9, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _rect10, _line6, _line7, _g19, _line8, _line9, _line10, _line11, _line12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovimemoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "591.939px",
    height: "135.333px",
    viewBox: "0 0 591.939 135.333",
    enableBackground: "new 0 0 591.939 135.333",
    xmlSpace: "preserve",
    shapeRendering: "optimizeQuality",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.597-209.302h8.399l-12.201,66.704h-7.1l10.5-55.604h-0.2l-18.5,33.502l-4.3-33.502h-0.2l-13.101,55.604h-7 l16.201-66.704h8.3l3.6,28.302L107.597-209.302z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.047-141.098H94.887l9.203-48.738L87.592-159.96l-3.901-30.402l-11.607,49.264H61.987l16.93-69.704h10.801 l3.187,25.048l13.808-25.048h11.085L105.047-141.098z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.396-176c-1.8,8.4-7,34.302-25.802,34.302c-19.002,0-13.002-25.702-11.201-34.302c2.3-11.001,8-34.202,25.802-34.202 C193.997-210.202,188.296-184.801,186.396-176z M156.395-176c-3.8,18.001-3.9,28.001,5.5,28.001 c11.601,0,15.001-16.401,17.501-28.001c2.7-12.601,6.2-27.902-5.602-27.902C161.995-203.902,158.495-185.801,156.395-176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.595-140.198c-4.891,0-8.664-1.596-11.217-4.744c-6.409-7.906-3.174-23.217-1.619-30.576l0.166-0.789 c1.831-8.754,7.401-35.395,27.271-35.395c4.879,0,8.646,1.602,11.196,4.762c6.487,8.041,3.017,24.101,1.535,30.959l-0.161,0.748 C185.916-166.568,180.283-140.198,160.595-140.198z M173.795-202.402c-10.238,0-13.685,16.168-15.745,25.828l-0.188,0.889 c-2.084,9.871-3.791,20.489-0.645,24.37c0.992,1.223,2.521,1.817,4.678,1.817c10.259,0,13.548-15.272,15.95-26.424l0.23-1.076 c1.839-8.571,4.128-19.238,0.74-23.43C177.743-201.756,176.101-202.402,173.795-202.402z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M265.096-210.602l6.5,1.4l-34.303,67.904h-1.6l-5.3-67.904l7.1-1.4l3,49.903h0.2L265.096-210.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217-139.798h-3.91l-5.513-70.618l10.094-1.99l2.783,46.293l22.593-46.203l9.547,2.056L238.217-139.798z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.063-210.802l9.003,0.011l-14.457,69.546h-8.351l14.458-69.546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.83-139.745h-11.415l14.832-71.351l0.816,0.169l0.002-1.375l10.845,0.014L311.83-139.745z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M387.045-141.098h-10.161l9.204-48.736l-16.499,29.874l-3.902-30.4l-11.607,49.262h-10.096l16.93-69.704h10.803 l3.186,25.048l13.81-25.048h11.085L387.045-141.098z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M422.593-194.701h32.502l-1.301,6h-25.802l-3.301,15.601h21.301l-1.299,6H423.39l-3.9,18.501h25.804l-1.302,6H411.49 L422.593-194.701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.202-141.098h-35.564l11.741-55.103h35.575l-1.95,9h-25.796l-2.666,12.601h21.311l-1.948,9h-21.296l-3.268,15.501 h25.812L445.202-141.098z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M483.091-184.801h-0.199l-10.301,42.203h-7.103l13.201-52.103h8.801l4.601,22.601l14.2-22.601h8.802l-9,52.103h-7.101 l7.699-42.203h-0.199l-17.602,27.502L483.091-184.801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.354-141.098h-10.161l6.734-36.914l-15.749,24.607l-5.288-25.072l-9.123,37.378H463.56l13.962-55.103h11.193 l4.097,20.131l12.649-20.131h11.41L507.354-141.098z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.794,
    y: -318.045,
    fill: "none",
    width: 538.146,
    height: 68.044
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 53.7942 -265.9448)",
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 100
  }, "MOVIMemo")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 546.2527 -233.4077)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 100
  }, "MOVIMemo")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M564.734-166.133c-0.899,4.2-6.001,26.901-24.202,26.901 c-8.399,0-17.201-6-12.801-26.901c4.4-20.801,15.701-27.002,24.302-27.002C560.335-193.135,569.234-187.135,564.734-166.133z  M534.732-166.133c-1.601,7.6-3,20.601,7.1,20.601c10.103,0,14.302-13.001,15.901-20.601c1.7-7.701,3-20.701-7.101-20.701 C540.531-186.834,536.432-173.834,534.732-166.133z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-69.44-205.725c0,1.394-0.358,2.523-0.801,2.523h-35.646c-0.442,0-0.8-1.129-0.8-2.523l0,0c0-1.394,0.357-2.523,0.8-2.523 h35.646C-69.798-208.248-69.44-207.119-69.44-205.725L-69.44-205.725z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.44-193.557c0,1.393-0.423,2.522-0.944,2.522h-42.084c-0.521,0-0.944-1.129-0.944-2.522l0,0 c0-1.395,0.424-2.523,0.944-2.523h42.084C-69.863-196.08-69.44-194.951-69.44-193.557L-69.44-193.557z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.44-181.474c0,1.394-0.358,2.523-0.801,2.523h-35.646c-0.442,0-0.8-1.129-0.8-2.523l0,0c0-1.394,0.357-2.523,0.8-2.523 h35.646C-69.798-183.998-69.44-182.868-69.44-181.474L-69.44-181.474z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.44-167.776c0,1.394-0.261,2.523-0.581,2.523H-95.9c-0.32,0-0.581-1.129-0.581-2.523l0,0 c0-1.394,0.26-2.523,0.581-2.523h25.879C-69.7-170.299-69.44-169.17-69.44-167.776L-69.44-167.776z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.44-154.891c0,1.394-0.358,2.523-0.801,2.523h-35.646c-0.442,0-0.8-1.129-0.8-2.523l0,0c0-1.394,0.357-2.523,0.8-2.523 h35.646C-69.798-157.415-69.44-156.285-69.44-154.891L-69.44-154.891z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.44-142.126c0,1.394-0.222,2.523-0.492,2.523h-21.946c-0.271,0-0.493-1.129-0.493-2.523l0,0 c0-1.394,0.221-2.523,0.493-2.523h21.946C-69.661-144.65-69.44-143.521-69.44-142.126L-69.44-142.126z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.781-205.779c0,1.363-0.358,2.468-0.8,2.468H43.335c-0.441,0-0.8-1.105-0.8-2.468l0,0c0-1.364,0.358-2.469,0.8-2.469 h35.646C79.423-208.248,79.781-207.143,79.781-205.779L79.781-205.779z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.781-193.875c0,1.363-0.423,2.468-0.944,2.468H36.752c-0.521,0-0.943-1.104-0.943-2.468l0,0 c0-1.364,0.423-2.469,0.943-2.469h42.084C79.358-196.344,79.781-195.239,79.781-193.875L79.781-193.875z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.781-182.054c0,1.363-0.358,2.468-0.8,2.468H43.335c-0.441,0-0.8-1.105-0.8-2.468l0,0c0-1.364,0.358-2.469,0.8-2.469 h35.646C79.423-184.522,79.781-183.417,79.781-182.054L79.781-182.054z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.875-168.652c0,1.363-0.242,2.468-0.54,2.468H53.28c-0.298,0-0.54-1.105-0.54-2.468l0,0c0-1.364,0.242-2.469,0.54-2.469 h24.055C77.633-171.121,77.875-170.016,77.875-168.652L77.875-168.652z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.998-156.046c0,1.363-0.312,2.468-0.697,2.468H43.232c-0.385,0-0.697-1.105-0.697-2.468l0,0 c0-1.364,0.312-2.469,0.697-2.469H74.3C74.686-158.515,74.998-157.41,74.998-156.046L74.998-156.046z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.998-143.558c0,1.363-0.175,2.468-0.39,2.468H54.24c-0.216,0-0.39-1.105-0.39-2.468l0,0c0-1.364,0.174-2.469,0.39-2.469 h17.368C71.823-146.026,71.998-144.922,71.998-143.558L71.998-143.558z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315.568-205.779c0,1.363-0.292,2.468-0.653,2.468h-29.162c-0.36,0-0.653-1.105-0.653-2.468l0,0 c0-1.364,0.293-2.469,0.653-2.469h29.162C315.276-208.248,315.568-207.143,315.568-205.779L315.568-205.779z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.568-193.875c0,1.363-0.345,2.468-0.771,2.468h-34.43c-0.427,0-0.771-1.104-0.771-2.468l0,0 c0-1.364,0.346-2.469,0.771-2.469h34.43C315.224-196.344,315.568-195.239,315.568-193.875L315.568-193.875z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M315.568-182.054c0,1.363-0.292,2.468-0.653,2.468h-29.162c-0.36,0-0.653-1.105-0.653-2.468l0,0 c0-1.364,0.293-2.469,0.653-2.469h29.162C315.276-184.522,315.568-183.417,315.568-182.054L315.568-182.054z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M314.01-168.652c0,1.363-0.197,2.468-0.44,2.468H293.89c-0.244,0-0.442-1.105-0.442-2.468l0,0 c0-1.364,0.198-2.469,0.442-2.469h19.679C313.812-171.121,314.01-170.016,314.01-168.652L314.01-168.652z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M311.656-156.046c0,1.363-0.255,2.468-0.569,2.468H285.67c-0.314,0-0.57-1.105-0.57-2.468l0,0 c0-1.364,0.255-2.469,0.57-2.469h25.417C311.401-158.515,311.656-157.41,311.656-156.046L311.656-156.046z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M237.782-205.779c0,1.363-0.292,2.468-0.651,2.468H208.1c-0.359,0-0.651-1.105-0.651-2.468l0,0 c0-1.364,0.292-2.469,0.651-2.469h29.029C237.49-208.248,237.782-207.143,237.782-205.779L237.782-205.779z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.597-193.875c0,1.363-0.365,2.468-0.815,2.468h-36.325c-0.45,0-0.814-1.104-0.814-2.468l0,0 c0-1.364,0.364-2.469,0.814-2.469h36.325C239.232-196.344,239.597-195.239,239.597-193.875L239.597-193.875z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M239.597-182.054c0,1.363-0.31,2.468-0.69,2.468h-30.768c-0.382,0-0.69-1.105-0.69-2.468l0,0 c0-1.364,0.309-2.469,0.69-2.469h30.768C239.288-184.522,239.597-183.417,239.597-182.054L239.597-182.054z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.952-168.652c0,1.363-0.208,2.468-0.465,2.468h-20.763c-0.259,0-0.467-1.105-0.467-2.468l0,0 c0-1.364,0.208-2.469,0.467-2.469h20.763C237.743-171.121,237.952-170.016,237.952-168.652L237.952-168.652z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M235.469-156.046c0,1.363-0.27,2.468-0.603,2.468h-26.816c-0.333,0-0.602-1.105-0.602-2.468l0,0 c0-1.364,0.271-2.469,0.602-2.469h26.816C235.2-158.515,235.469-157.41,235.469-156.046L235.469-156.046z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M235.469-143.558c0,1.363-0.151,2.468-0.337,2.468h-14.99c-0.188,0-0.337-1.105-0.337-2.468l0,0 c0-1.364,0.149-2.469,0.337-2.469h14.99C235.318-146.026,235.469-144.922,235.469-143.558L235.469-143.558z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M307.758-143.558c0,1.363-0.144,2.468-0.319,2.468H293.23c-0.177,0-0.319-1.105-0.319-2.468l0,0 c0-1.364,0.144-2.469,0.319-2.469h14.208C307.614-146.026,307.758-144.922,307.758-143.558L307.758-143.558z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M172.333-205.779c0,1.363-0.323,2.468-0.721,2.468h-32.151c-0.397,0-0.721-1.105-0.721-2.468l0,0 c0-1.364,0.323-2.469,0.721-2.469h32.151C172.011-208.248,172.333-207.143,172.333-205.779L172.333-205.779z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M161.968-193.875c0,1.363-0.284,2.468-0.636,2.468H132.97c-0.352,0-0.637-1.104-0.637-2.468l0,0 c0-1.364,0.285-2.469,0.637-2.469h28.361C161.683-196.344,161.968-195.239,161.968-193.875L161.968-193.875z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M157.998-182.054c0,1.363-0.324,2.468-0.723,2.468h-32.218c-0.399,0-0.724-1.105-0.724-2.468l0,0 c0-1.364,0.324-2.469,0.724-2.469h32.218C157.674-184.522,157.998-183.417,157.998-182.054L157.998-182.054z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.537-168.652c0,1.363-0.229,2.468-0.51,2.468h-22.724c-0.282,0-0.511-1.105-0.511-2.468l0,0 c0-1.364,0.229-2.469,0.511-2.469h22.724C155.309-171.121,155.537-170.016,155.537-168.652L155.537-168.652z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M154.416-156.046c0,1.363-0.186,2.468-0.417,2.468h-18.583c-0.229,0-0.417-1.105-0.417-2.468l0,0 c0-1.364,0.188-2.469,0.417-2.469H154C154.23-158.515,154.416-157.41,154.416-156.046L154.416-156.046z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M157.998-143.558c0,1.363-0.175,2.468-0.39,2.468H140.24c-0.216,0-0.39-1.105-0.39-2.468l0,0 c0-1.364,0.174-2.469,0.39-2.469h17.368C157.823-146.026,157.998-144.922,157.998-143.558L157.998-143.558z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.597-93.646h8.399l-12.201,66.704h-7.1l10.5-55.604h-0.2l-18.5,33.503l-4.3-33.502h-0.2L70.895-26.942h-7 l16.201-66.704h8.3l3.6,28.302L107.597-93.646z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.047-25.442H94.887l9.203-48.738L87.592-44.304L83.69-74.706L72.083-25.442H61.987l16.93-69.704h10.801l3.187,25.048 l13.808-25.048h11.085L105.047-25.442z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.396-60.344c-1.8,8.4-7,34.302-25.802,34.302c-19.002,0-13.002-25.702-11.201-34.302 c2.3-11.001,8-34.202,25.802-34.202C193.997-94.546,188.296-69.145,186.396-60.344z M156.395-60.344 c-3.8,18.001-3.9,28.001,5.5,28.001c11.601,0,15.001-16.401,17.501-28.001c2.7-12.601,6.2-27.902-5.602-27.902 C161.995-88.246,158.495-70.145,156.395-60.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.595-24.542c-4.891,0-8.664-1.596-11.217-4.744c-6.409-7.906-3.174-23.217-1.619-30.576l0.166-0.789 c1.831-8.754,7.401-35.395,27.271-35.395c4.879,0,8.646,1.602,11.196,4.762c6.487,8.041,3.017,24.101,1.535,30.959l-0.161,0.748 C185.916-50.912,180.283-24.542,160.595-24.542z M173.795-86.746c-10.238,0-13.685,16.168-15.745,25.828l-0.188,0.889 c-2.084,9.871-3.791,20.489-0.645,24.37c0.992,1.223,2.521,1.817,4.678,1.817c10.259,0,13.548-15.272,15.95-26.424l0.23-1.076 c1.839-8.571,4.128-19.238,0.74-23.43C177.743-86.1,176.101-86.746,173.795-86.746z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M265.096-94.946l6.5,1.4l-34.303,67.904h-1.6l-5.3-67.904l7.1-1.4l3,49.903h0.2L265.096-94.946z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217-24.142h-3.91l-5.513-70.618l10.094-1.99l2.783,46.293l22.593-46.203l9.547,2.056L238.217-24.142z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M316.063-95.146l9.003,0.011l-14.457,69.546h-8.351l14.458-69.546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.83-24.089h-11.415l15.65-72.557l10.845,0.014L311.83-24.089z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4B6AB2",
    d: "M387.045-25.442h-10.161l9.204-48.736l-16.499,29.874l-3.902-30.4l-11.607,49.262h-10.096l16.93-69.704 h10.803l3.186,25.048l13.81-25.048h11.085L387.045-25.442z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4B6AB2",
    d: "M422.593-79.045h32.502l-1.301,6h-25.802l-3.301,15.601h21.301l-1.299,6H423.39l-3.9,18.501h25.804 l-1.302,6H411.49L422.593-79.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B6AB2",
    d: "M445.202-25.442h-35.564l11.741-55.103h35.575l-1.95,9h-25.796l-2.666,12.601h21.311l-1.948,9h-21.296 l-3.268,15.501h25.812L445.202-25.442z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4B6AB2",
    d: "M483.091-69.145h-0.199l-10.301,42.203h-7.103l13.201-52.103h8.801l4.601,22.601l14.2-22.601h8.802 l-9,52.103h-7.101l7.699-42.203h-0.199L488.89-41.643L483.091-69.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B6AB2",
    d: "M507.354-25.442h-10.161l6.734-36.914l-15.749,24.607l-5.288-25.072l-9.123,37.378H463.56l13.962-55.103 h11.193l4.097,20.131l12.649-20.131h11.41L507.354-25.442z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4B6AB2",
    d: "M564.734-50.477c-0.899,4.2-6.001,26.901-24.202,26.901c-8.399,0-17.201-6-12.801-26.901 c4.4-20.801,15.701-27.002,24.302-27.002C560.335-77.479,569.234-71.479,564.734-50.477z M534.732-50.477 c-1.601,7.6-3,20.601,7.1,20.601c10.103,0,14.302-13.001,15.901-20.601c1.7-7.701,3-20.701-7.101-20.701 C540.531-71.178,536.432-58.178,534.732-50.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B69B2",
    d: "M540.532-23.076c-3.179,0-7.64-0.827-10.837-4.769c-3.813-4.701-4.64-12.35-2.453-22.736 c5.378-25.423,20.335-27.399,24.791-27.399c4.466,0,8.298,1.698,10.791,4.782c3.823,4.73,4.631,12.41,2.399,22.825 C563.465-42.165,557.536-23.076,540.532-23.076z M552.033-76.979c-4.266,0-18.59,1.918-23.812,26.605 c-2.121,10.076-1.364,17.444,2.251,21.899c2.949,3.635,7.099,4.398,10.061,4.398c16.274,0,22.005-18.537,23.713-26.506 c2.166-10.105,1.427-17.503-2.198-21.986C559.099-76.214,554.975-76.979,552.033-76.979z M541.832-29.376 c-2.729,0-4.857-0.917-6.325-2.727c-3.383-4.168-2.555-12.349-1.264-18.477c3.046-13.804,8.713-21.098,16.391-21.098 c2.755,0,4.9,0.933,6.379,2.772c3.438,4.279,2.556,12.441,1.21,18.536C556.571-42.532,552.245-29.376,541.832-29.376z  M550.634-70.678c-9.034,0-13.368,11.044-15.412,20.309c-1.245,5.911-2.072,13.774,1.062,17.636 c1.27,1.564,3.137,2.357,5.55,2.357c9.709,0,13.823-12.659,15.412-20.204c1.063-4.819,2.347-13.519-1.012-17.698 C554.953-69.871,553.069-70.678,550.634-70.678z"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.753-91.092c0,1.018-0.357,1.843-0.8,1.843H44.307c-0.442,0-0.801-0.825-0.801-1.843l0,0 c0-1.019,0.358-1.843,0.801-1.843h35.646C80.395-92.935,80.753-92.11,80.753-91.092L80.753-91.092z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.753-80.205c0,1.018-0.423,1.843-0.943,1.843H37.724c-0.521,0-0.944-0.825-0.944-1.843l0,0 c0-1.018,0.423-1.843,0.944-1.843h42.084C80.33-82.048,80.753-81.223,80.753-80.205L80.753-80.205z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M80.753-69.38c0,1.018-0.357,1.843-0.8,1.843H44.307c-0.442,0-0.801-0.825-0.801-1.843l0,0c0-1.018,0.358-1.843,0.801-1.843 h35.646C80.395-71.223,80.753-70.398,80.753-69.38L80.753-69.38z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.847-59.375c0,1.018-0.242,1.843-0.54,1.843H54.252c-0.298,0-0.54-0.825-0.54-1.843l0,0c0-1.018,0.242-1.843,0.54-1.843 h24.056C78.605-61.218,78.847-60.393,78.847-59.375L78.847-59.375z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.97-49.963c0,1.017-0.175,1.842-0.391,1.842H58.185c-0.216,0-0.392-0.825-0.392-1.842l0,0 c0-1.019,0.176-1.843,0.392-1.843H75.58C75.795-51.807,75.97-50.982,75.97-49.963L75.97-49.963z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M236.192-49.963c0,1.017-0.174,1.842-0.39,1.842h-17.396c-0.216,0-0.391-0.825-0.391-1.842l0,0 c0-1.019,0.175-1.843,0.391-1.843h17.396C236.018-51.807,236.192-50.982,236.192-49.963L236.192-49.963z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.718-49.92c0,1.017-0.173,1.842-0.389,1.842h-17.33c-0.216,0-0.39-0.825-0.39-1.842l0,0c0-1.019,0.174-1.843,0.39-1.843 h17.33C152.544-51.764,152.718-50.939,152.718-49.92L152.718-49.92z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M71.218-31.078c0,1.017-0.174,1.842-0.39,1.842H53.433c-0.217,0-0.392-0.825-0.392-1.842l0,0 c0-1.019,0.175-1.843,0.392-1.843h17.395C71.043-32.921,71.218-32.097,71.218-31.078L71.218-31.078z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.97-40.641c0,1.018-0.229,1.843-0.51,1.843H49.786c-0.282,0-0.509-0.825-0.509-1.843l0,0 c0-1.019,0.227-1.843,0.509-1.843h22.675C72.742-42.483,72.97-41.659,72.97-40.641L72.97-40.641z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M315.986-91.092c0,1.018-0.304,1.843-0.68,1.843h-30.3c-0.376,0-0.68-0.825-0.68-1.843l0,0c0-1.019,0.304-1.843,0.68-1.843 h30.3C315.683-92.935,315.986-92.11,315.986-91.092L315.986-91.092z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M315.986-80.205c0,1.018-0.358,1.843-0.803,1.843h-35.772c-0.443,0-0.803-0.825-0.803-1.843l0,0 c0-1.018,0.358-1.843,0.803-1.843h35.772C315.628-82.048,315.986-81.223,315.986-80.205L315.986-80.205z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M315.986-69.38c0,1.018-0.304,1.843-0.68,1.843h-30.3c-0.376,0-0.68-0.825-0.68-1.843l0,0c0-1.018,0.304-1.843,0.68-1.843 h30.3C315.683-71.223,315.986-70.398,315.986-69.38L315.986-69.38z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M314.366-59.375c0,1.018-0.206,1.843-0.458,1.843h-20.447c-0.254,0-0.459-0.825-0.459-1.843l0,0 c0-1.018,0.205-1.843,0.459-1.843h20.447C314.16-61.218,314.366-60.393,314.366-59.375L314.366-59.375z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M311.922-49.963c0,1.017-0.148,1.842-0.332,1.842h-14.786c-0.185,0-0.332-0.825-0.332-1.842l0,0 c0-1.019,0.147-1.843,0.332-1.843h14.786C311.772-51.807,311.922-50.982,311.922-49.963L311.922-49.963z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M307.882-31.078c0,1.017-0.148,1.842-0.332,1.842h-14.786c-0.184,0-0.332-0.825-0.332-1.842l0,0 c0-1.019,0.148-1.843,0.332-1.843h14.786C307.733-32.921,307.882-32.097,307.882-31.078L307.882-31.078z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M309.371-40.641c0,1.018-0.193,1.843-0.433,1.843h-19.273c-0.24,0-0.433-0.825-0.433-1.843l0,0 c0-1.019,0.192-1.843,0.433-1.843h19.273C309.177-42.483,309.371-41.659,309.371-40.641L309.371-40.641z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M238.244-91.092c0,1.018-0.26,1.843-0.581,1.843h-25.879c-0.321,0-0.581-0.825-0.581-1.843l0,0 c0-1.019,0.26-1.843,0.581-1.843h25.879C237.984-92.935,238.244-92.11,238.244-91.092L238.244-91.092z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M238.244-80.205c0,1.018-0.352,1.843-0.786,1.843h-35.029c-0.435,0-0.786-0.825-0.786-1.843l0,0 c0-1.018,0.352-1.843,0.786-1.843h35.029C237.892-82.048,238.244-81.223,238.244-80.205L238.244-80.205z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M238.244-69.38c0,1.018-0.219,1.843-0.489,1.843h-21.808c-0.271,0-0.489-0.825-0.489-1.843l0,0 c0-1.018,0.22-1.843,0.489-1.843h21.808C238.025-71.223,238.244-70.398,238.244-69.38L238.244-69.38z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M236.338-59.375c0,1.018-0.241,1.843-0.54,1.843h-24.055c-0.298,0-0.54-0.825-0.54-1.843l0,0 c0-1.018,0.242-1.843,0.54-1.843h24.055C236.096-61.218,236.338-60.393,236.338-59.375L236.338-59.375z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M235.938-31.078c0,1.017-0.237,1.842-0.531,1.842h-23.672c-0.294,0-0.532-0.825-0.532-1.842l0,0 c0-1.019,0.238-1.843,0.532-1.843h23.672C235.701-32.921,235.938-32.097,235.938-31.078L235.938-31.078z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M238.697-40.641c0,1.018-0.184,1.843-0.41,1.843h-18.256c-0.228,0-0.41-0.825-0.41-1.843l0,0 c0-1.019,0.184-1.843,0.41-1.843h18.256C238.514-42.483,238.697-41.659,238.697-40.641L238.697-40.641z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M166.695-91.092c0,1.018-0.27,1.843-0.6,1.843H139.34c-0.332,0-0.6-0.825-0.6-1.843l0,0c0-1.019,0.269-1.843,0.6-1.843 h26.755C166.426-92.935,166.695-92.11,166.695-91.092L166.695-91.092z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M158.912-80.205c0,1.018-0.228,1.843-0.509,1.843h-22.675c-0.281,0-0.509-0.825-0.509-1.843l0,0 c0-1.018,0.228-1.843,0.509-1.843h22.675C158.684-82.048,158.912-81.223,158.912-80.205L158.912-80.205z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M156.337-69.38c0,1.018-0.258,1.843-0.576,1.843h-25.733c-0.319,0-0.577-0.825-0.577-1.843l0,0 c0-1.018,0.258-1.843,0.577-1.843h25.733C156.079-71.223,156.337-70.398,156.337-69.38L156.337-69.38z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M156.395-59.375c0,1.018-0.31,1.843-0.688,1.843h-30.684c-0.38,0-0.689-0.825-0.689-1.843l0,0 c0-1.018,0.31-1.843,0.689-1.843h30.684C156.086-61.218,156.395-60.393,156.395-59.375L156.395-59.375z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M157.16-31.078c0,1.017-0.174,1.842-0.39,1.842h-17.396c-0.216,0-0.391-0.825-0.391-1.842l0,0 c0-1.019,0.175-1.843,0.391-1.843h17.396C156.985-32.921,157.16-32.097,157.16-31.078L157.16-31.078z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M152.718-40.641c0,1.018-0.224,1.843-0.5,1.843h-22.269c-0.277,0-0.5-0.825-0.5-1.843l0,0c0-1.019,0.223-1.843,0.5-1.843 h22.269C152.494-42.483,152.718-41.659,152.718-40.641L152.718-40.641z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-70.384-110.996c0,1.393-0.358,2.523-0.8,2.523h-35.646c-0.441,0-0.8-1.13-0.8-2.523l0,0c0-1.394,0.358-2.523,0.8-2.523 h35.646C-70.742-113.519-70.384-112.39-70.384-110.996L-70.384-110.996z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-70.384-98.828c0,1.394-0.423,2.523-0.944,2.523h-42.084c-0.521,0-0.943-1.129-0.943-2.523l0,0 c0-1.394,0.423-2.523,0.943-2.523h42.084C-70.807-101.352-70.384-100.222-70.384-98.828L-70.384-98.828z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M-70.384-86.745c0,1.393-0.358,2.523-0.8,2.523h-35.646c-0.441,0-0.8-1.13-0.8-2.523l0,0c0-1.394,0.358-2.523,0.8-2.523 h35.646C-70.742-89.269-70.384-88.139-70.384-86.745L-70.384-86.745z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.29-73.047c0,1.393-0.242,2.523-0.54,2.523h-24.055c-0.298,0-0.54-1.13-0.54-2.523l0,0c0-1.394,0.242-2.523,0.54-2.523 h24.055C-72.532-75.57-72.29-74.441-72.29-73.047L-72.29-73.047z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-75.167-60.162c0,1.393-0.312,2.523-0.696,2.523h-31.068c-0.385,0-0.697-1.13-0.697-2.523l0,0 c0-1.394,0.312-2.523,0.697-2.523h31.068C-75.479-62.686-75.167-61.556-75.167-60.162L-75.167-60.162z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M-78.167-47.397c0,1.393-0.175,2.523-0.39,2.523h-17.368c-0.216,0-0.39-1.13-0.39-2.523l0,0c0-1.394,0.174-2.523,0.39-2.523 h17.368C-78.342-49.921-78.167-48.792-78.167-47.397L-78.167-47.397z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: -18.997,
    y1: 29.725,
    x2: -40.628,
    y2: 133.392
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "#170CF4",
    x1: -6.919,
    y1: 30.32,
    x2: -29.813,
    y2: 123.155
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "#170CF4",
    x1: -40.628,
    y1: 30.32,
    x2: -63.522,
    y2: 123.155
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "#170CF4",
    x1: -55.274,
    y1: 27.704,
    x2: -78.167,
    y2: 120.539
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 310.657 436.8667)",
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 105
  }, "Memo")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 311.657 436.8667)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 105
  }, "Memo")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 318.928,
    y: 455.207,
    fill: "none",
    width: 319.479,
    height: 19.572
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 318.9285 466.1479)",
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 21
  }, "Memos On The Move")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 318.9285 466.1479)",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 21
  }, "Memos On The Move")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 310.656,
    y: 382.162,
    fill: "none",
    width: 538.146,
    height: 68.045
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.969,
    y1: -252.3369,
    x2: 155.0774,
    y2: -252.3369,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M146.718,411.724c0,1.018-0.173,1.844-0.389,1.844h-17.33c-0.216,0-0.39-0.826-0.39-1.844l0,0 c0-1.02,0.174-1.843,0.39-1.843h17.33C146.544,409.882,146.718,410.707,146.718,411.724L146.718,411.724z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.0999,
    y1: -211.1655,
    x2: 169.0549,
    y2: -211.1655,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M160.695,370.553c0,1.019-0.27,1.843-0.6,1.843H133.34c-0.332,0-0.6-0.824-0.6-1.843l0,0 c0-1.019,0.269-1.843,0.6-1.843h26.755C160.426,368.71,160.695,369.535,160.695,370.553L160.695,370.553z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.5793,
    y1: -222.0522,
    x2: 161.2717,
    y2: -222.0522,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M152.912,381.441c0,1.018-0.228,1.842-0.509,1.842h-22.675c-0.281,0-0.509-0.824-0.509-1.842l0,0 c0-1.019,0.228-1.844,0.509-1.844h22.675C152.684,379.597,152.912,380.422,152.912,381.441L152.912,381.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8098,
    y1: -232.8779,
    x2: 158.6965,
    y2: -232.8779,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M150.337,392.265c0,1.018-0.258,1.844-0.576,1.844h-25.733c-0.319,0-0.577-0.826-0.577-1.844l0,0 c0-1.018,0.258-1.843,0.577-1.843h25.733C150.079,390.422,150.337,391.248,150.337,392.265L150.337,392.265z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.6936,
    y1: -242.8823,
    x2: 158.7551,
    y2: -242.8823,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M150.395,402.271c0,1.018-0.31,1.842-0.688,1.842h-30.684c-0.38,0-0.689-0.824-0.689-1.842l0,0 c0-1.019,0.31-1.844,0.689-1.844h30.684C150.086,400.427,150.395,401.252,150.395,402.271L150.395,402.271z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.344,
    y1: -271.1787,
    x2: 159.5198,
    y2: -271.1787,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M151.16,430.568c0,1.017-0.174,1.842-0.39,1.842h-17.396c-0.216,0-0.391-0.825-0.391-1.842l0,0 c0-1.021,0.175-1.845,0.391-1.845h17.396C150.985,428.723,151.16,429.548,151.16,430.568L151.16,430.568z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8088,
    y1: -261.6167,
    x2: 155.0774,
    y2: -261.6167,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M146.718,421.005c0,1.018-0.224,1.842-0.5,1.842h-22.269c-0.277,0-0.5-0.824-0.5-1.842l0,0 c0-1.02,0.223-1.844,0.5-1.844h22.269C146.494,419.162,146.718,419.986,146.718,421.005L146.718,421.005z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.9543,
    y1: -271.1787,
    x2: 137.6663,
    y2: -271.1787,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M129.306,430.566c0,1.006-0.815,1.821-1.82,1.821h-0.072c-1.005,0-1.819-0.815-1.819-1.821l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C128.491,428.746,129.306,429.562,129.306,430.566L129.306,430.566z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.6868,
    y1: -211.1655,
    x2: 316.2419,
    y2: -211.1655,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M307.882,370.553c0,1.019-0.322,1.843-0.721,1.843h-32.114c-0.398,0-0.72-0.824-0.72-1.843l0,0 c0-1.019,0.322-1.843,0.72-1.843h32.114C307.56,368.71,307.882,369.535,307.882,370.553L307.882,370.553z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.968,
    y1: -222.0522,
    x2: 314.3464,
    y2: -222.0522,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M305.986,381.441c0,1.018-0.359,1.842-0.803,1.842h-35.772c-0.443,0-0.803-0.824-0.803-1.842l0,0 c0-1.019,0.358-1.844,0.803-1.844h35.772C305.627,379.597,305.986,380.422,305.986,381.441L305.986,381.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.6868,
    y1: -232.8779,
    x2: 314.3464,
    y2: -232.8779,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M305.986,392.265c0,1.018-0.304,1.844-0.68,1.844h-30.3c-0.376,0-0.68-0.826-0.68-1.844l0,0 c0-1.018,0.304-1.843,0.68-1.843h30.3C305.683,390.422,305.986,391.248,305.986,392.265L305.986,392.265z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.3616,
    y1: -242.8823,
    x2: 312.7263,
    y2: -242.8823,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M304.366,402.271c0,1.018-0.206,1.842-0.458,1.842h-20.447c-0.254,0-0.459-0.824-0.459-1.842l0,0 c0-1.019,0.205-1.844,0.459-1.844h20.447C304.16,400.427,304.366,401.252,304.366,402.271L304.366,402.271z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.8323,
    y1: -252.2939,
    x2: 307.6609,
    y2: -252.2939,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M299.301,411.681c0,1.018-0.122,1.844-0.274,1.844h-12.278c-0.152,0-0.275-0.826-0.275-1.844l0,0 c0-1.02,0.123-1.843,0.275-1.843h12.278C299.178,409.839,299.301,410.664,299.301,411.681L299.301,411.681z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.7913,
    y1: -271.1787,
    x2: 306.241,
    y2: -271.1787,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M297.881,430.568c0,1.017-0.147,1.842-0.332,1.842h-14.785c-0.184,0-0.332-0.825-0.332-1.842l0,0 c0-1.021,0.148-1.845,0.332-1.845h14.785C297.733,428.723,297.881,429.548,297.881,430.568L297.881,430.568z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.592,
    y1: -261.6167,
    x2: 307.7312,
    y2: -261.6167,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M299.371,421.005c0,1.018-0.193,1.842-0.433,1.842h-19.273c-0.24,0-0.433-0.824-0.433-1.842l0,0 c0-1.02,0.192-1.844,0.433-1.844h19.273C299.177,419.162,299.371,419.986,299.371,421.005L299.371,421.005z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.0999,
    y1: -271.1787,
    x2: 286.8118,
    y2: -271.1787,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M278.452,430.566c0,1.006-0.814,1.821-1.82,1.821h-0.071c-1.005,0-1.82-0.815-1.82-1.821l0,0 c0-1.004,0.815-1.82,1.82-1.82h0.071C277.637,428.746,278.452,429.562,278.452,430.566L278.452,430.566z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.9807,
    y1: -261.6167,
    x2: 237.0569,
    y2: -261.6167,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M228.697,421.005c0,1.018-0.184,1.842-0.41,1.842h-18.256c-0.228,0-0.41-0.824-0.41-1.842l0,0 c0-1.02,0.184-1.844,0.41-1.844h18.256C228.514,419.162,228.697,419.986,228.697,421.005L228.697,421.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.3762,
    y1: -252.2939,
    x2: 234.552,
    y2: -252.2939,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M226.192,411.681c0,1.018-0.174,1.844-0.39,1.844h-17.396c-0.216,0-0.391-0.826-0.391-1.844l0,0 c0-1.02,0.175-1.843,0.391-1.843h17.396C226.018,409.839,226.192,410.664,226.192,411.681L226.192,411.681z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.5627,
    y1: -211.1655,
    x2: 236.6038,
    y2: -211.1655,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M228.244,370.553c0,1.019-0.26,1.843-0.581,1.843h-25.879c-0.321,0-0.581-0.824-0.581-1.843l0,0 c0-1.019,0.26-1.843,0.581-1.843h25.879C227.984,368.71,228.244,369.535,228.244,370.553L228.244,370.553z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.0022,
    y1: -222.0522,
    x2: 236.6038,
    y2: -222.0522,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M228.244,381.441c0,1.018-0.352,1.842-0.786,1.842h-35.029c-0.435,0-0.786-0.824-0.786-1.842l0,0 c0-1.019,0.352-1.844,0.786-1.844h35.029C227.892,379.597,228.244,380.422,228.244,381.441L228.244,381.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.8176,
    y1: -232.8779,
    x2: 236.6038,
    y2: -232.8779,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M228.244,392.265c0,1.018-0.219,1.844-0.489,1.844h-21.808c-0.271,0-0.489-0.826-0.489-1.844l0,0 c0-1.018,0.22-1.843,0.489-1.843h21.808C228.025,390.422,228.244,391.248,228.244,392.265L228.244,392.265z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.5627,
    y1: -242.8823,
    x2: 234.6975,
    y2: -242.8823,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M226.338,402.271c0,1.018-0.241,1.842-0.54,1.842h-24.055c-0.298,0-0.54-0.824-0.54-1.842l0,0 c0-1.019,0.242-1.844,0.54-1.844h24.055C226.096,400.427,226.338,401.252,226.338,402.271L226.338,402.271z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.5627,
    y1: -271.1787,
    x2: 236.2981,
    y2: -271.1787,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M227.938,430.568c0,1.017-0.237,1.842-0.531,1.842h-23.672c-0.294,0-0.532-0.825-0.532-1.842l0,0 c0-1.021,0.238-1.845,0.532-1.845h23.672C227.701,428.723,227.938,429.548,227.938,430.568L227.938,430.568z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.9612,
    y1: -261.6172,
    x2: 214.6731,
    y2: -261.6172,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M206.313,421.004c0,1.006-0.815,1.821-1.82,1.821h-0.072c-1.005,0-1.819-0.815-1.819-1.821l0,0 c0-1.005,0.814-1.82,1.819-1.82h0.072C205.499,419.183,206.313,420,206.313,421.004L206.313,421.004z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2981,
    y1: -211.1655,
    x2: 80.307,
    y2: -211.1655,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M80.753,370.553c0,1.019-0.357,1.843-0.8,1.843H44.307c-0.442,0-0.801-0.824-0.801-1.843l0,0 c0-1.019,0.358-1.843,0.801-1.843h35.646C80.395,368.71,80.753,369.535,80.753,370.553L80.753,370.553z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1941,
    y1: -222.0522,
    x2: 76.9724,
    y2: -222.0522,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M76.831,381.441c0,1.018-0.385,1.842-0.859,1.842H37.64c-0.476,0-0.86-0.824-0.86-1.842l0,0 c0-1.019,0.385-1.844,0.86-1.844h38.331C76.446,379.597,76.831,380.422,76.831,381.441L76.831,381.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3367,
    y1: -232.8779,
    x2: 74.947,
    y2: -232.8779,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M74.202,392.265c0,1.018-0.295,1.844-0.659,1.844H44.167c-0.363,0-0.659-0.826-0.659-1.844l0,0 c0-1.018,0.296-1.843,0.659-1.843h29.376C73.907,390.422,74.202,391.248,74.202,392.265L74.202,392.265z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.7502,
    y1: -242.8823,
    x2: 74.7188,
    y2: -242.8823,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M71.772,402.271c0,1.018-0.174,1.842-0.389,1.842H54.101c-0.214,0-0.389-0.824-0.389-1.842l0,0 c0-1.019,0.175-1.844,0.389-1.844h17.283C71.598,400.427,71.772,401.252,71.772,402.271L71.772,402.271z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.6428,
    y1: -252.2939,
    x2: 74.7284,
    y2: -252.2939,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M69.486,411.681c0,1.018-0.112,1.844-0.251,1.844h-11.19c-0.139,0-0.251-0.826-0.251-1.844l0,0 c0-1.02,0.112-1.843,0.251-1.843h11.189C69.374,409.839,69.486,410.664,69.486,411.681L69.486,411.681z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0842,
    y1: -271.1787,
    x2: 74.2958,
    y2: -271.1787,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M66.279,430.568c0,1.017-0.127,1.842-0.285,1.842H53.327c-0.157,0-0.285-0.825-0.285-1.842l0,0 c0-1.021,0.127-1.845,0.285-1.845h12.668C66.152,428.723,66.279,429.548,66.279,430.568L66.279,430.568z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.9578,
    y1: -261.6167,
    x2: 74.9825,
    y2: -261.6167,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M68.25,421.005c0,1.018-0.183,1.842-0.407,1.842H49.685c-0.227,0-0.408-0.824-0.408-1.842l0,0 c0-1.02,0.182-1.844,0.408-1.844h18.157C68.067,419.162,68.25,419.986,68.25,421.005L68.25,421.005z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0979,
    y1: -271.1787,
    x2: 79.1029,
    y2: -271.1787,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M49.277,430.566c0,1.006-0.815,1.821-1.82,1.821h-0.072c-1.005,0-1.819-0.815-1.819-1.821l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C48.462,428.746,49.277,429.562,49.277,430.566L49.277,430.566z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.3469,
    y1: -241.9634,
    x2: 126.1565,
    y2: -241.9634,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3599,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5427,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7254,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M105.047,436.203H94.887l9.203-48.737l-16.499,29.876l-3.901-30.402l-11.607,49.264H61.987 l16.93-69.703h10.801l3.187,25.048l13.808-25.048h11.085L105.047,436.203z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.4226,
    y1: -241.9634,
    x2: 193.0652,
    y2: -241.9634,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M182.396,401.301c-1.8,8.401-7,34.302-25.802,34.302c-19.002,0-13.002-25.701-11.201-34.302 c2.3-11.001,8-34.202,25.802-34.202C189.997,367.099,184.296,392.5,182.396,401.301z M152.395,401.301 c-3.8,18-3.9,28.001,5.5,28.001c11.601,0,15.001-16.4,17.501-28.001c2.7-12.601,6.2-27.901-5.602-27.901 C157.995,373.4,154.495,391.5,152.395,401.301z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.9133,
    y1: -241.9634,
    x2: 194.55,
    y2: -241.9634,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M156.595,437.103c-4.891,0-8.664-1.597-11.217-4.744c-6.409-7.906-3.174-23.218-1.619-30.576 l0.166-0.789c1.831-8.754,7.401-35.395,27.271-35.395c4.879,0,8.646,1.602,11.196,4.762c6.487,8.041,3.017,24.102,1.535,30.959 l-0.161,0.748C181.916,410.734,176.283,437.103,156.595,437.103z M169.795,374.9c-10.238,0-13.685,16.168-15.745,25.828 l-0.188,0.889c-2.084,9.871-3.791,20.488-0.645,24.369c0.992,1.224,2.521,1.817,4.678,1.817c10.259,0,13.548-15.272,15.95-26.424 l0.23-1.076c1.839-8.571,4.128-19.237,0.74-23.431C173.743,375.545,172.101,374.9,169.795,374.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.7542,
    y1: -241.9634,
    x2: 272.9563,
    y2: -241.9634,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5135,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M258.096,366.699l6.5,1.4l-34.303,67.904h-1.6l-5.3-67.904l7.1-1.4l3,49.904h0.2L258.096,366.699z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.1536,
    y1: -241.812,
    x2: 275.1702,
    y2: -241.812,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5135,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M231.217,437.503h-3.91l-5.513-70.617l10.094-1.99l2.783,46.293l22.593-46.203l9.547,2.057 L231.217,437.503z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.947,
    y1: -241.8369,
    x2: 326.6228,
    y2: -241.8369,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M300.344,437.553h-10.757l17.918-72.657h10.757L300.344,437.553z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.78,
    y1: 445.7798,
    x2: 565.9441,
    y2: 445.7798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C79BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C75BC"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.78,
    y: 443.447,
    fill: "url(#SVGID_39_)",
    width: 529.164,
    height: 4.666
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "#2D17FF",
    x1: 320.137,
    y1: 342.447,
    x2: 320.137,
    y2: 469.947
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 318.928,
    y: 112.76,
    fill: "none",
    width: 319.479,
    height: 19.572
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.844,124.202h-2.512l1.759-9.315l-3.179,5.755l-0.761-5.935l-2.237,9.495h-2.501l3.644-15.004h2.576l0.618,4.857 l2.678-4.857h2.658L329.844,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.051,124.202h-7.845l2.545-11.939h7.848l-0.489,2.26h-5.416l-0.48,2.275h4.475l-0.489,2.26h-4.47l-0.608,2.885h5.421 L342.051,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.109,124.202h-2.511l1.286-7.046l-3.045,4.759l-1.035-4.912l-1.757,7.199h-2.525l3.025-11.939h2.645l0.798,3.923 l2.465-3.923h2.718L355.109,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.984,124.391c-1.064,0-1.981-0.407-2.582-1.147c-0.879-1.084-1.079-2.801-0.595-5.104 c1.19-5.629,4.581-6.066,5.592-6.066c1.059,0,1.973,0.408,2.572,1.15c0.882,1.091,1.078,2.814,0.583,5.123 C368.164,120.165,366.84,124.391,362.984,124.391z M365.104,114.397c-1.633,0-2.451,2.15-2.85,3.953 c-0.344,1.633-0.293,2.831,0.144,3.369c0.193,0.238,0.466,0.349,0.858,0.349c1.76,0,2.541-2.461,2.85-3.928 c0.354-1.608,0.305-2.841-0.134-3.387C365.777,114.51,365.501,114.397,365.104,114.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375.689,124.391c-1.069,0-1.954-0.334-2.561-0.967c-0.639-0.666-0.949-1.638-0.899-2.81l0.016-0.356l2.339-0.695 l-0.011,0.682c-0.012,0.715,0.122,1.219,0.397,1.498c0.215,0.219,0.54,0.325,0.991,0.325c0.807,0,1.746-0.381,1.968-1.449 c0.167-0.764-0.198-1.003-1.205-1.449l-0.616-0.276c-1.334-0.593-2.846-1.264-2.356-3.548c0.393-1.925,2.165-3.271,4.31-3.271 c1.993,0,3.147,1.146,3.25,3.227l0.021,0.398l-2.435,0.68l-0.013-0.646c-0.022-1.174-0.56-1.336-1.138-1.336 c-0.68,0-1.436,0.325-1.589,1.052c-0.141,0.624,0.029,0.773,0.815,1.145l2.126,1.031c1.107,0.7,1.529,1.798,1.235,3.12 C379.865,122.958,378.041,124.391,375.689,124.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M406.67,116.884c-0.396,1.856-1.6,7.507-5.886,7.507c-1.086,0-1.927-0.358-2.5-1.065 c-1.401-1.729-0.708-5.004-0.375-6.577l0.034-0.162c0.392-1.874,1.583-7.578,5.905-7.578c1.083,0,1.923,0.359,2.495,1.069 c1.418,1.758,0.676,5.191,0.358,6.657 M403.555,111.331c-2,0-2.704,3.301-3.125,5.273l-0.04,0.189 c-0.403,1.911-0.787,4.203-0.172,4.962c0.108,0.134,0.314,0.312,0.838,0.312c2.004,0,2.677-3.121,3.168-5.399l0.049-0.228 c0.378-1.762,0.848-3.954,0.191-4.765C404.277,111.444,403.979,111.331,403.555,111.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M417.483,124.202h-2.537l-1.826-7.353l-0.104,0.615l-1.432,6.737h-2.43l2.544-11.939h2.539l1.82,7.397l0.108-0.64 l1.432-6.758h2.43L417.483,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M439.765,124.202h-2.429l2.708-12.744h-3.026l0.489-2.26h8.414l-0.489,2.26h-2.958L439.765,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M455.198,124.202h-2.428l1.092-5.145h-3.303l-1.092,5.145h-2.431l2.545-11.939h2.43l-0.967,4.535h3.303l0.965-4.535h2.431 L455.198,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M468.049,124.202h-7.845l2.545-11.939h7.848l-0.489,2.26h-5.416l-0.48,2.275h4.475l-0.489,2.26h-4.47l-0.608,2.885h5.421 L468.049,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M493.64,124.202h-2.511l1.76-9.318l-3.181,5.758l-0.761-5.932l-2.237,9.492h-2.5l3.643-15.004h2.577l0.618,4.857 l2.678-4.857h2.658L493.64,124.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.583,124.391c-1.064,0-1.981-0.407-2.582-1.147c-0.879-1.084-1.079-2.801-0.595-5.104 c1.19-5.629,4.58-6.066,5.591-6.066c1.059,0,1.973,0.408,2.572,1.15c0.882,1.091,1.078,2.814,0.583,5.123 C506.763,120.165,505.443,124.391,501.583,124.391z M503.703,114.397c-1.634,0-2.452,2.15-2.851,3.953 c-0.344,1.632-0.293,2.83,0.145,3.369c0.193,0.238,0.466,0.349,0.858,0.349c1.76,0,2.541-2.461,2.85-3.928 c0.354-1.607,0.305-2.841-0.135-3.387C504.375,114.51,504.099,114.397,503.703,114.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M514.571,124.475h-0.958l-2.011-11.816l2.435-0.835l1.135,7.227l4.216-7.188l2.155,0.891L514.571,124.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M531.049,124.202h-7.846l2.544-11.939h7.849l-0.49,2.26h-5.414l-0.481,2.275h4.476l-0.49,2.26h-4.471l-0.607,2.885h5.421 L531.049,124.202z"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 311.781,
    y: 39.715,
    fill: "none",
    width: 538.146,
    height: 68.045
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.969,
    y1: 90.1099,
    x2: 155.0774,
    y2: 90.1099,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M146.718,69.278c0,1.018-0.173,1.844-0.389,1.844h-17.33c-0.216,0-0.39-0.826-0.39-1.844l0,0 c0-1.02,0.174-1.843,0.39-1.843h17.33C146.544,67.436,146.718,68.26,146.718,69.278L146.718,69.278z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.0999,
    y1: 131.2808,
    x2: 169.0549,
    y2: 131.2808,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M160.695,28.106c0,1.019-0.27,1.843-0.6,1.843H133.34c-0.332,0-0.6-0.824-0.6-1.843l0,0 c0-1.019,0.269-1.843,0.6-1.843h26.755C160.426,26.264,160.695,27.088,160.695,28.106L160.695,28.106z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.5793,
    y1: 120.394,
    x2: 161.2717,
    y2: 120.394,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M152.912,38.994c0,1.018-0.228,1.842-0.509,1.842h-22.675c-0.281,0-0.509-0.824-0.509-1.842l0,0 c0-1.019,0.228-1.844,0.509-1.844h22.675C152.684,37.15,152.912,37.976,152.912,38.994L152.912,38.994z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8098,
    y1: 109.5688,
    x2: 158.6965,
    y2: 109.5688,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M150.337,49.818c0,1.018-0.258,1.844-0.576,1.844h-25.733c-0.319,0-0.577-0.826-0.577-1.844l0,0 c0-1.018,0.258-1.843,0.577-1.843h25.733C150.079,47.976,150.337,48.801,150.337,49.818L150.337,49.818z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.6936,
    y1: 99.564,
    x2: 158.7551,
    y2: 99.564,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M150.395,59.824c0,1.018-0.31,1.842-0.688,1.842h-30.684c-0.38,0-0.689-0.824-0.689-1.842l0,0 c0-1.019,0.31-1.844,0.689-1.844h30.684C150.086,57.98,150.395,58.806,150.395,59.824L150.395,59.824z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.344,
    y1: 71.2681,
    x2: 159.5198,
    y2: 71.2681,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M151.16,88.122c0,1.016-0.174,1.842-0.39,1.842h-17.396c-0.216,0-0.391-0.826-0.391-1.842l0,0 c0-1.021,0.175-1.846,0.391-1.846h17.396C150.985,86.276,151.16,87.102,151.16,88.122L151.16,88.122z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8088,
    y1: 80.8296,
    x2: 155.0774,
    y2: 80.8296,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M146.718,78.559c0,1.018-0.224,1.842-0.5,1.842h-22.269c-0.277,0-0.5-0.824-0.5-1.842l0,0 c0-1.02,0.223-1.844,0.5-1.844h22.269C146.494,76.715,146.718,77.54,146.718,78.559L146.718,78.559z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.9543,
    y1: 71.2681,
    x2: 137.6663,
    y2: 71.2681,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M129.306,88.12c0,1.006-0.815,1.82-1.82,1.82h-0.072c-1.005,0-1.819-0.814-1.819-1.82l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C128.491,86.299,129.306,87.116,129.306,88.12L129.306,88.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.6868,
    y1: 131.2808,
    x2: 316.2419,
    y2: 131.2808,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M307.882,28.106c0,1.019-0.322,1.843-0.721,1.843h-32.114c-0.398,0-0.72-0.824-0.72-1.843l0,0 c0-1.019,0.322-1.843,0.72-1.843h32.114C307.56,26.264,307.882,27.088,307.882,28.106L307.882,28.106z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.968,
    y1: 120.394,
    x2: 314.3464,
    y2: 120.394,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M305.986,38.994c0,1.018-0.359,1.842-0.803,1.842h-35.772c-0.443,0-0.803-0.824-0.803-1.842l0,0 c0-1.019,0.358-1.844,0.803-1.844h35.772C305.627,37.15,305.986,37.976,305.986,38.994L305.986,38.994z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.6868,
    y1: 109.5688,
    x2: 314.3464,
    y2: 109.5688,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M305.986,49.818c0,1.018-0.304,1.844-0.68,1.844h-30.3c-0.376,0-0.68-0.826-0.68-1.844l0,0 c0-1.018,0.304-1.843,0.68-1.843h30.3C305.683,47.976,305.986,48.801,305.986,49.818L305.986,49.818z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.3616,
    y1: 99.564,
    x2: 312.7263,
    y2: 99.564,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M304.366,59.824c0,1.018-0.206,1.842-0.458,1.842h-20.447c-0.254,0-0.459-0.824-0.459-1.842l0,0 c0-1.019,0.205-1.844,0.459-1.844h20.447C304.16,57.98,304.366,58.806,304.366,59.824L304.366,59.824z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.8323,
    y1: 90.1528,
    x2: 307.6609,
    y2: 90.1528,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M299.301,69.235c0,1.018-0.122,1.844-0.274,1.844h-12.278c-0.152,0-0.275-0.826-0.275-1.844l0,0 c0-1.02,0.123-1.843,0.275-1.843h12.278C299.178,67.393,299.301,68.217,299.301,69.235L299.301,69.235z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.7913,
    y1: 71.2681,
    x2: 306.241,
    y2: 71.2681,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M297.881,88.122c0,1.016-0.147,1.842-0.332,1.842h-14.785c-0.184,0-0.332-0.826-0.332-1.842l0,0 c0-1.021,0.148-1.846,0.332-1.846h14.785C297.733,86.276,297.881,87.102,297.881,88.122L297.881,88.122z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.592,
    y1: 80.8296,
    x2: 307.7312,
    y2: 80.8296,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M299.371,78.559c0,1.018-0.193,1.842-0.433,1.842h-19.273c-0.24,0-0.433-0.824-0.433-1.842l0,0 c0-1.02,0.192-1.844,0.433-1.844h19.273C299.177,76.715,299.371,77.54,299.371,78.559L299.371,78.559z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.0999,
    y1: 71.2681,
    x2: 286.8118,
    y2: 71.2681,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M278.452,88.12c0,1.006-0.814,1.82-1.82,1.82h-0.071c-1.005,0-1.82-0.814-1.82-1.82l0,0 c0-1.004,0.815-1.82,1.82-1.82h0.071C277.637,86.299,278.452,87.116,278.452,88.12L278.452,88.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.9807,
    y1: 80.8296,
    x2: 237.0569,
    y2: 80.8296,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M228.697,78.559c0,1.018-0.184,1.842-0.41,1.842h-18.256c-0.228,0-0.41-0.824-0.41-1.842l0,0 c0-1.02,0.184-1.844,0.41-1.844h18.256C228.514,76.715,228.697,77.54,228.697,78.559L228.697,78.559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.3762,
    y1: 90.1528,
    x2: 234.552,
    y2: 90.1528,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M226.192,69.235c0,1.018-0.174,1.844-0.39,1.844h-17.396c-0.216,0-0.391-0.826-0.391-1.844l0,0 c0-1.02,0.175-1.843,0.391-1.843h17.396C226.018,67.393,226.192,68.217,226.192,69.235L226.192,69.235z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.5627,
    y1: 131.2808,
    x2: 236.6038,
    y2: 131.2808,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M228.244,28.106c0,1.019-0.26,1.843-0.581,1.843h-25.879c-0.321,0-0.581-0.824-0.581-1.843l0,0 c0-1.019,0.26-1.843,0.581-1.843h25.879C227.984,26.264,228.244,27.088,228.244,28.106L228.244,28.106z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.0022,
    y1: 120.394,
    x2: 236.6038,
    y2: 120.394,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M228.244,38.994c0,1.018-0.352,1.842-0.786,1.842h-35.029c-0.435,0-0.786-0.824-0.786-1.842l0,0 c0-1.019,0.352-1.844,0.786-1.844h35.029C227.892,37.15,228.244,37.976,228.244,38.994L228.244,38.994z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.8176,
    y1: 109.5688,
    x2: 236.6038,
    y2: 109.5688,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M228.244,49.818c0,1.018-0.219,1.844-0.489,1.844h-21.808c-0.271,0-0.489-0.826-0.489-1.844l0,0 c0-1.018,0.22-1.843,0.489-1.843h21.808C228.025,47.976,228.244,48.801,228.244,49.818L228.244,49.818z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.5627,
    y1: 99.564,
    x2: 234.6975,
    y2: 99.564,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_61_)",
    d: "M226.338,59.824c0,1.018-0.241,1.842-0.54,1.842h-24.055c-0.298,0-0.54-0.824-0.54-1.842l0,0 c0-1.019,0.242-1.844,0.54-1.844h24.055C226.096,57.98,226.338,58.806,226.338,59.824L226.338,59.824z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.5627,
    y1: 71.2681,
    x2: 236.2981,
    y2: 71.2681,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M227.938,88.122c0,1.016-0.237,1.842-0.531,1.842h-23.672c-0.294,0-0.532-0.826-0.532-1.842l0,0 c0-1.021,0.238-1.846,0.532-1.846h23.672C227.701,86.276,227.938,87.102,227.938,88.122L227.938,88.122z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.9612,
    y1: 80.8296,
    x2: 214.6731,
    y2: 80.8296,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M206.313,78.557c0,1.006-0.815,1.822-1.82,1.822h-0.072c-1.005,0-1.819-0.816-1.819-1.822l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C205.499,76.737,206.313,77.553,206.313,78.557L206.313,78.557z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2981,
    y1: 131.2808,
    x2: 80.307,
    y2: 131.2808,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_64_)",
    d: "M80.753,28.106c0,1.019-0.357,1.843-0.8,1.843H44.307c-0.442,0-0.801-0.824-0.801-1.843l0,0 c0-1.019,0.358-1.843,0.801-1.843h35.646C80.395,26.264,80.753,27.088,80.753,28.106L80.753,28.106z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1941,
    y1: 120.394,
    x2: 76.9724,
    y2: 120.394,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_65_)",
    d: "M76.831,38.994c0,1.018-0.385,1.842-0.859,1.842H37.64c-0.476,0-0.86-0.824-0.86-1.842l0,0 c0-1.019,0.385-1.844,0.86-1.844h38.331C76.446,37.15,76.831,37.976,76.831,38.994L76.831,38.994z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3367,
    y1: 109.5688,
    x2: 74.947,
    y2: 109.5688,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_66_)",
    d: "M74.202,49.818c0,1.018-0.295,1.844-0.659,1.844H44.167c-0.363,0-0.659-0.826-0.659-1.844l0,0 c0-1.018,0.296-1.843,0.659-1.843h29.376C73.907,47.976,74.202,48.801,74.202,49.818L74.202,49.818z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.7502,
    y1: 99.564,
    x2: 74.7188,
    y2: 99.564,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_67_)",
    d: "M71.772,59.824c0,1.018-0.174,1.842-0.389,1.842H54.101c-0.214,0-0.389-0.824-0.389-1.842l0,0 c0-1.019,0.175-1.844,0.389-1.844h17.283C71.598,57.98,71.772,58.806,71.772,59.824L71.772,59.824z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.6428,
    y1: 90.1528,
    x2: 74.7284,
    y2: 90.1528,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_68_)",
    d: "M69.486,69.235c0,1.018-0.112,1.844-0.251,1.844h-11.19c-0.139,0-0.251-0.826-0.251-1.844l0,0 c0-1.02,0.112-1.843,0.251-1.843h11.189C69.374,67.393,69.486,68.217,69.486,69.235L69.486,69.235z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0842,
    y1: 71.2681,
    x2: 74.2958,
    y2: 71.2681,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_69_)",
    d: "M66.279,88.122c0,1.016-0.127,1.842-0.285,1.842H53.327c-0.157,0-0.285-0.826-0.285-1.842l0,0 c0-1.021,0.127-1.846,0.285-1.846h12.668C66.152,86.276,66.279,87.102,66.279,88.122L66.279,88.122z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.9578,
    y1: 80.8296,
    x2: 74.9825,
    y2: 80.8296,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_70_)",
    d: "M68.25,78.559c0,1.018-0.183,1.842-0.407,1.842H49.685c-0.227,0-0.408-0.824-0.408-1.842l0,0 c0-1.02,0.182-1.844,0.408-1.844h18.157C68.067,76.715,68.25,77.54,68.25,78.559L68.25,78.559z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0979,
    y1: 71.2681,
    x2: 79.1029,
    y2: 71.2681,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_71_)",
    d: "M49.277,88.12c0,1.006-0.815,1.82-1.82,1.82h-0.072c-1.005,0-1.819-0.814-1.819-1.82l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C48.462,86.299,49.277,87.116,49.277,88.12L49.277,88.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.0872,
    y1: 100.4829,
    x2: 126.1565,
    y2: 100.4829,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3599,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5427,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7254,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_72_)",
    d: "M104.935,94.657H94.824l9.266-49.638L87.592,74.895L83.69,44.492L71.885,94.657H61.727 l17.501-71.504h10.663l3.012,25.948l13.969-25.948h10.924L104.935,94.657z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.4226,
    y1: 100.4829,
    x2: 193.0652,
    y2: 100.4829,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_73_)",
    d: "M182.396,58.854c-1.8,8.401-7,34.302-25.802,34.302c-19.002,0-13.002-25.702-11.201-34.302 c2.3-11.001,8-34.202,25.802-34.202C189.997,24.652,184.296,50.054,182.396,58.854z M152.395,58.854c-3.8,18-3.9,28.001,5.5,28.001 c11.601,0,15.001-16.4,17.501-28.001c2.7-12.601,6.2-27.901-5.602-27.901C157.995,30.953,154.495,49.054,152.395,58.854z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.9133,
    y1: 100.4829,
    x2: 194.55,
    y2: 100.4829,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_74_)",
    d: "M156.595,94.657c-4.891,0-8.664-1.598-11.217-4.744c-6.409-7.906-3.174-23.218-1.619-30.577 l0.166-0.789c1.831-8.754,7.401-35.395,27.271-35.395c4.879,0,8.646,1.602,11.196,4.762c6.487,8.041,3.017,24.102,1.535,30.959 l-0.161,0.748C181.916,68.288,176.283,94.657,156.595,94.657z M169.795,32.453c-10.238,0-13.685,16.168-15.745,25.828l-0.188,0.889 c-2.084,9.872-3.791,20.489-0.645,24.37c0.992,1.223,2.521,1.816,4.678,1.816c10.259,0,13.548-15.271,15.95-26.423l0.23-1.076 c1.839-8.571,4.128-19.237,0.74-23.431C173.743,33.099,172.101,32.453,169.795,32.453z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.7542,
    y1: 100.4829,
    x2: 272.9563,
    y2: 100.4829,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5135,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_75_)",
    d: "M258.096,24.252l6.5,1.4l-34.303,67.905h-1.6l-5.3-67.905l7.1-1.4l3,49.905h0.2L258.096,24.252z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.1536,
    y1: 100.4829,
    x2: 275.1702,
    y2: 100.4829,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5135,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_76_)",
    d: "M231.419,94.657h-4.144l-5.481-70.217l10.136-1.287l2.741,45.59l22.293-45.59l9.847,1.443 L231.419,94.657z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.0583,
    y1: 100.4829,
    x2: 326.6228,
    y2: 100.4829,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_77_)",
    d: "M300.415,94.649l-10.717,0.008l17.634-71.504l10.931,0.001L300.415,94.649z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.78,
    y1: 103.3335,
    x2: 565.9441,
    y2: 103.3335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C79BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C75BC"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.78,
    y: 101,
    fill: "url(#SVGID_78_)",
    width: 529.164,
    height: 4.666
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M365.015,94.705h-10.32l9.552-50.585l-17.113,30.989l-4.045-31.506l-12.041,51.102h-10.251l17.41-71.679h11.007 l3.304,25.97l14.316-25.97h11.291L365.015,94.705z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.951,94.705h-36.498l12.066-56.634h36.509l-1.979,9.127h-26.582L405.69,60.33h21.961l-1.979,9.127H403.73 l-3.398,16.12h26.596L424.951,94.705z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488.998,94.705h-10.322l6.993-38.319l-16.334,25.521l-5.478-25.979l-9.465,38.777h-10.364l14.349-56.634h11.417 l4.247,20.866l13.11-20.866h11.63L488.998,94.705z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.49,94.657c-5.14,0-9.571-1.974-12.478-5.558c-4.217-5.195-5.188-13.37-2.888-24.297 c5.647-26.699,21.829-28.775,26.654-28.775c5.112,0,9.528,1.98,12.435,5.574c4.225,5.226,5.178,13.432,2.829,24.389 C550.496,91.864,535.626,94.657,529.49,94.657z M539.404,47.937c-7.29,0-10.99,9.828-12.811,18.072 c-1.55,7.363-1.345,12.946,0.567,15.304c0.795,0.979,1.94,1.435,3.605,1.435c7.854,0,11.394-11.243,12.804-17.945 c1.601-7.249,1.406-12.999-0.521-15.396C542.245,48.404,541.086,47.937,539.404,47.937z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 318.928,
    y: 277.26,
    fill: "none",
    width: 319.479,
    height: 19.572
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 318.9285 288.2017)",
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 21
  }, "Memos On The Move")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 318.9285 288.2017)",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    fontFamily: "'OratorStd-Slanted'",
    fontSize: 21
  }, "Memos On The Move")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 311.781,
    y: 204.215,
    fill: "none",
    width: 538.146,
    height: 68.045
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.969,
    y1: -74.3901,
    x2: 155.0774,
    y2: -74.3901,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_79_)",
    d: "M146.718,233.778c0,1.018-0.173,1.844-0.389,1.844h-17.33c-0.216,0-0.39-0.826-0.39-1.844l0,0 c0-1.02,0.174-1.844,0.39-1.844h17.33C146.544,231.936,146.718,232.76,146.718,233.778L146.718,233.778z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.0999,
    y1: -33.2192,
    x2: 169.0549,
    y2: -33.2192,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_80_)",
    d: "M160.695,192.606c0,1.02-0.27,1.844-0.6,1.844H133.34c-0.332,0-0.6-0.824-0.6-1.844l0,0 c0-1.018,0.269-1.842,0.6-1.842h26.755C160.426,190.764,160.695,191.588,160.695,192.606L160.695,192.606z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.5793,
    y1: -44.106,
    x2: 161.2717,
    y2: -44.106,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_81_)",
    d: "M152.912,203.495c0,1.018-0.228,1.842-0.509,1.842h-22.675c-0.281,0-0.509-0.824-0.509-1.842l0,0 c0-1.02,0.228-1.844,0.509-1.844h22.675C152.684,201.651,152.912,202.475,152.912,203.495L152.912,203.495z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8098,
    y1: -54.9312,
    x2: 158.6965,
    y2: -54.9312,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_82_)",
    d: "M150.337,214.319c0,1.018-0.258,1.844-0.576,1.844h-25.733c-0.319,0-0.577-0.826-0.577-1.844l0,0 c0-1.018,0.258-1.844,0.577-1.844h25.733C150.079,212.475,150.337,213.301,150.337,214.319L150.337,214.319z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.6936,
    y1: -64.936,
    x2: 158.7551,
    y2: -64.936,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_83_)",
    d: "M150.395,224.325c0,1.018-0.31,1.842-0.688,1.842h-30.684c-0.38,0-0.689-0.824-0.689-1.842l0,0 c0-1.02,0.31-1.844,0.689-1.844h30.684C150.086,222.481,150.395,223.305,150.395,224.325L150.395,224.325z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.344,
    y1: -93.2319,
    x2: 159.5198,
    y2: -93.2319,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_84_)",
    d: "M151.16,252.622c0,1.016-0.174,1.842-0.39,1.842h-17.396c-0.216,0-0.391-0.826-0.391-1.842l0,0 c0-1.021,0.175-1.846,0.391-1.846h17.396C150.985,250.776,151.16,251.602,151.16,252.622L151.16,252.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8088,
    y1: -83.6704,
    x2: 155.0774,
    y2: -83.6704,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_85_)",
    d: "M146.718,243.059c0,1.018-0.224,1.842-0.5,1.842h-22.269c-0.277,0-0.5-0.824-0.5-1.842l0,0 c0-1.02,0.223-1.844,0.5-1.844h22.269C146.494,241.215,146.718,242.04,146.718,243.059L146.718,243.059z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.9543,
    y1: -93.2319,
    x2: 137.6663,
    y2: -93.2319,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_86_)",
    d: "M129.306,252.62c0,1.006-0.815,1.82-1.82,1.82h-0.072c-1.005,0-1.819-0.814-1.819-1.82l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C128.491,250.799,129.306,251.616,129.306,252.62L129.306,252.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.6868,
    y1: -33.2192,
    x2: 316.2419,
    y2: -33.2192,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_87_)",
    d: "M307.882,192.606c0,1.02-0.322,1.844-0.721,1.844h-32.114c-0.398,0-0.72-0.824-0.72-1.844l0,0 c0-1.018,0.322-1.842,0.72-1.842h32.114C307.56,190.764,307.882,191.588,307.882,192.606L307.882,192.606z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.968,
    y1: -44.106,
    x2: 314.3464,
    y2: -44.106,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_88_)",
    d: "M305.986,203.495c0,1.018-0.359,1.842-0.803,1.842h-35.772c-0.443,0-0.803-0.824-0.803-1.842l0,0 c0-1.02,0.358-1.844,0.803-1.844h35.772C305.627,201.651,305.986,202.475,305.986,203.495L305.986,203.495z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.6868,
    y1: -54.9312,
    x2: 314.3464,
    y2: -54.9312,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_89_)",
    d: "M305.986,214.319c0,1.018-0.304,1.844-0.68,1.844h-30.3c-0.376,0-0.68-0.826-0.68-1.844l0,0 c0-1.018,0.304-1.844,0.68-1.844h30.3C305.683,212.475,305.986,213.301,305.986,214.319L305.986,214.319z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.3616,
    y1: -64.936,
    x2: 312.7263,
    y2: -64.936,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_90_)",
    d: "M304.366,224.325c0,1.018-0.206,1.842-0.458,1.842h-20.447c-0.254,0-0.459-0.824-0.459-1.842l0,0 c0-1.02,0.205-1.844,0.459-1.844h20.447C304.16,222.481,304.366,223.305,304.366,224.325L304.366,224.325z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.8323,
    y1: -74.3472,
    x2: 307.6609,
    y2: -74.3472,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_91_)",
    d: "M299.301,233.735c0,1.018-0.122,1.844-0.274,1.844h-12.278c-0.152,0-0.275-0.826-0.275-1.844l0,0 c0-1.02,0.123-1.844,0.275-1.844h12.278C299.178,231.893,299.301,232.717,299.301,233.735L299.301,233.735z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.7913,
    y1: -93.2319,
    x2: 306.241,
    y2: -93.2319,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_92_)",
    d: "M297.881,252.622c0,1.016-0.147,1.842-0.332,1.842h-14.785c-0.184,0-0.332-0.826-0.332-1.842l0,0 c0-1.021,0.148-1.846,0.332-1.846h14.785C297.733,250.776,297.881,251.602,297.881,252.622L297.881,252.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.592,
    y1: -83.6704,
    x2: 307.7312,
    y2: -83.6704,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_93_)",
    d: "M299.371,243.059c0,1.018-0.193,1.842-0.433,1.842h-19.273c-0.24,0-0.433-0.824-0.433-1.842l0,0 c0-1.02,0.192-1.844,0.433-1.844h19.273C299.177,241.215,299.371,242.04,299.371,243.059L299.371,243.059z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.0999,
    y1: -93.2319,
    x2: 286.8118,
    y2: -93.2319,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_94_)",
    d: "M278.452,252.62c0,1.006-0.814,1.82-1.82,1.82h-0.071c-1.005,0-1.82-0.814-1.82-1.82l0,0 c0-1.004,0.815-1.82,1.82-1.82h0.071C277.637,250.799,278.452,251.616,278.452,252.62L278.452,252.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.9807,
    y1: -83.6704,
    x2: 237.0569,
    y2: -83.6704,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_95_)",
    d: "M228.697,243.059c0,1.018-0.184,1.842-0.41,1.842h-18.256c-0.228,0-0.41-0.824-0.41-1.842l0,0 c0-1.02,0.184-1.844,0.41-1.844h18.256C228.514,241.215,228.697,242.04,228.697,243.059L228.697,243.059z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.3762,
    y1: -74.3472,
    x2: 234.552,
    y2: -74.3472,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_96_)",
    d: "M226.192,233.735c0,1.018-0.174,1.844-0.39,1.844h-17.396c-0.216,0-0.391-0.826-0.391-1.844l0,0 c0-1.02,0.175-1.844,0.391-1.844h17.396C226.018,231.893,226.192,232.717,226.192,233.735L226.192,233.735z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.5627,
    y1: -33.2192,
    x2: 236.6038,
    y2: -33.2192,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_97_)",
    d: "M228.244,192.606c0,1.02-0.26,1.844-0.581,1.844h-25.879c-0.321,0-0.581-0.824-0.581-1.844l0,0 c0-1.018,0.26-1.842,0.581-1.842h25.879C227.984,190.764,228.244,191.588,228.244,192.606L228.244,192.606z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.0022,
    y1: -44.106,
    x2: 236.6038,
    y2: -44.106,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_98_)",
    d: "M228.244,203.495c0,1.018-0.352,1.842-0.786,1.842h-35.029c-0.435,0-0.786-0.824-0.786-1.842l0,0 c0-1.02,0.352-1.844,0.786-1.844h35.029C227.892,201.651,228.244,202.475,228.244,203.495L228.244,203.495z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.8176,
    y1: -54.9312,
    x2: 236.6038,
    y2: -54.9312,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_99_)",
    d: "M228.244,214.319c0,1.018-0.219,1.844-0.489,1.844h-21.808c-0.271,0-0.489-0.826-0.489-1.844l0,0 c0-1.018,0.22-1.844,0.489-1.844h21.808C228.025,212.475,228.244,213.301,228.244,214.319L228.244,214.319z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.5627,
    y1: -64.936,
    x2: 234.6975,
    y2: -64.936,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_100_)",
    d: "M226.338,224.325c0,1.018-0.241,1.842-0.54,1.842h-24.055c-0.298,0-0.54-0.824-0.54-1.842l0,0 c0-1.02,0.242-1.844,0.54-1.844h24.055C226.096,222.481,226.338,223.305,226.338,224.325L226.338,224.325z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.5627,
    y1: -93.2319,
    x2: 236.2981,
    y2: -93.2319,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_101_)",
    d: "M227.938,252.622c0,1.016-0.237,1.842-0.531,1.842h-23.672c-0.294,0-0.532-0.826-0.532-1.842l0,0 c0-1.021,0.238-1.846,0.532-1.846h23.672C227.701,250.776,227.938,251.602,227.938,252.622L227.938,252.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.9612,
    y1: -83.6704,
    x2: 214.6731,
    y2: -83.6704,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_102_)",
    d: "M206.313,243.057c0,1.006-0.815,1.822-1.82,1.822h-0.072c-1.005,0-1.819-0.816-1.819-1.822l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C205.499,241.237,206.313,242.053,206.313,243.057L206.313,243.057z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2981,
    y1: -33.2192,
    x2: 80.307,
    y2: -33.2192,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_103_)",
    d: "M80.753,192.606c0,1.02-0.357,1.844-0.8,1.844H44.307c-0.442,0-0.801-0.824-0.801-1.844l0,0 c0-1.018,0.358-1.842,0.801-1.842h35.646C80.395,190.764,80.753,191.588,80.753,192.606L80.753,192.606z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1941,
    y1: -44.106,
    x2: 76.9724,
    y2: -44.106,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_104_)",
    d: "M76.831,203.495c0,1.018-0.385,1.842-0.859,1.842H37.64c-0.476,0-0.86-0.824-0.86-1.842l0,0 c0-1.02,0.385-1.844,0.86-1.844h38.331C76.446,201.651,76.831,202.475,76.831,203.495L76.831,203.495z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3367,
    y1: -54.9312,
    x2: 74.947,
    y2: -54.9312,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_105_)",
    d: "M74.202,214.319c0,1.018-0.295,1.844-0.659,1.844H44.167c-0.363,0-0.659-0.826-0.659-1.844l0,0 c0-1.018,0.296-1.844,0.659-1.844h29.376C73.907,212.475,74.202,213.301,74.202,214.319L74.202,214.319z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.7502,
    y1: -64.936,
    x2: 74.7188,
    y2: -64.936,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_106_)",
    d: "M71.772,224.325c0,1.018-0.174,1.842-0.389,1.842H54.101c-0.214,0-0.389-0.824-0.389-1.842l0,0 c0-1.02,0.175-1.844,0.389-1.844h17.283C71.598,222.481,71.772,223.305,71.772,224.325L71.772,224.325z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.6428,
    y1: -74.3472,
    x2: 74.7284,
    y2: -74.3472,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_107_)",
    d: "M69.486,233.735c0,1.018-0.112,1.844-0.251,1.844h-11.19c-0.139,0-0.251-0.826-0.251-1.844l0,0 c0-1.02,0.112-1.844,0.251-1.844h11.189C69.374,231.893,69.486,232.717,69.486,233.735L69.486,233.735z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0842,
    y1: -93.2319,
    x2: 74.2958,
    y2: -93.2319,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_108_)",
    d: "M66.279,252.622c0,1.016-0.127,1.842-0.285,1.842H53.327c-0.157,0-0.285-0.826-0.285-1.842l0,0 c0-1.021,0.127-1.846,0.285-1.846h12.668C66.152,250.776,66.279,251.602,66.279,252.622L66.279,252.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.9578,
    y1: -83.6704,
    x2: 74.9825,
    y2: -83.6704,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_109_)",
    d: "M68.25,243.059c0,1.018-0.183,1.842-0.407,1.842H49.685c-0.227,0-0.408-0.824-0.408-1.842l0,0 c0-1.02,0.182-1.844,0.408-1.844h18.157C68.067,241.215,68.25,242.04,68.25,243.059L68.25,243.059z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0979,
    y1: -93.2319,
    x2: 79.1029,
    y2: -93.2319,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    style: {
      stopColor: "#27AAE1"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_110_)",
    d: "M49.277,252.62c0,1.006-0.815,1.82-1.82,1.82h-0.072c-1.005,0-1.819-0.814-1.819-1.82l0,0 c0-1.004,0.814-1.82,1.819-1.82h0.072C48.462,250.799,49.277,251.616,49.277,252.62L49.277,252.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.0872,
    y1: -64.0171,
    x2: 126.1565,
    y2: -64.0171,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3599,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5427,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7254,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_111_)",
    d: "M104.935,259.157H94.824l9.266-49.639l-16.499,29.877l-3.901-30.402l-11.805,50.164H61.727 l17.501-71.504h10.663l3.012,25.947l13.969-25.947h10.924L104.935,259.157z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.4226,
    y1: -64.0171,
    x2: 193.0652,
    y2: -64.0171,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_112_)",
    d: "M182.396,223.354c-1.8,8.402-7,34.303-25.802,34.303c-19.002,0-13.002-25.701-11.201-34.303 c2.3-11,8-34.201,25.802-34.201C189.997,189.153,184.296,214.553,182.396,223.354z M152.395,223.354c-3.8,18-3.9,28.002,5.5,28.002 c11.601,0,15.001-16.4,17.501-28.002c2.7-12.6,6.2-27.9-5.602-27.9C157.995,195.454,154.495,213.553,152.395,223.354z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.9133,
    y1: -64.0171,
    x2: 194.55,
    y2: -64.0171,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_113_)",
    d: "M156.595,259.157c-4.891,0-8.664-1.598-11.217-4.744c-6.409-7.906-3.174-23.219-1.619-30.576 l0.166-0.789c1.831-8.754,7.401-35.395,27.271-35.395c4.879,0,8.646,1.602,11.196,4.762c6.487,8.041,3.017,24.102,1.535,30.959 l-0.161,0.748C181.916,232.788,176.283,259.157,156.595,259.157z M169.795,196.954c-10.238,0-13.685,16.168-15.745,25.828 l-0.188,0.889c-2.084,9.871-3.791,20.488-0.645,24.369c0.992,1.223,2.521,1.816,4.678,1.816c10.259,0,13.548-15.271,15.95-26.424 l0.23-1.076c1.839-8.57,4.128-19.236,0.74-23.43C173.743,197.598,172.101,196.954,169.795,196.954z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.7542,
    y1: -64.0171,
    x2: 272.9563,
    y2: -64.0171,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5135,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_114_)",
    d: "M258.096,188.752l6.5,1.4l-34.303,67.904h-1.6l-5.3-67.904l7.1-1.4l3,49.904h0.2L258.096,188.752z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.1536,
    y1: -64.0171,
    x2: 275.1702,
    y2: -64.0171,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5135,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8061,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_115_)",
    d: "M231.419,259.157h-4.144l-5.481-70.217l10.136-1.287l2.741,45.59l22.293-45.59l9.847,1.443 L231.419,259.157z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.0583,
    y1: -64.0171,
    x2: 326.6228,
    y2: -64.0171,
    gradientTransform: "matrix(1 0 0 -1 -8.3599 159.3877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3491,
    style: {
      stopColor: "#24A0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    style: {
      stopColor: "#2193D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#1E83C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_116_)",
    d: "M300.415,259.149l-10.717,0.008l17.634-71.504h10.931L300.415,259.149z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.78,
    y1: 267.8335,
    x2: 565.9441,
    y2: 267.8335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C79BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#27A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C75BC"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36.78,
    y: 265.5,
    fill: "url(#SVGID_117_)",
    width: 529.164,
    height: 4.666
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "#F41650",
    x1: 38.237,
    y1: 259.157,
    x2: 562.593,
    y2: 259.157
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "#F41650",
    x1: 42.188,
    y1: 187.653,
    x2: 566.544,
    y2: 187.653
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M365.015,259.205h-10.32l9.552-50.585l-17.113,30.989l-4.045-31.507l-12.041,51.103h-10.251l17.41-71.679h11.007 l3.304,25.969l14.316-25.969h11.291L365.015,259.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.951,259.205h-36.498l12.066-56.634h36.509l-1.979,9.127h-26.582l-2.777,13.132h21.961l-1.979,9.127H403.73 l-3.398,16.12h26.596L424.951,259.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488.998,259.205h-10.322l6.993-38.319l-16.334,25.521l-5.478-25.979l-9.465,38.777h-10.364l14.349-56.634h11.417 l4.247,20.865l13.11-20.865h11.63L488.998,259.205z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.49,259.157c-5.14,0-9.571-1.974-12.478-5.558c-4.217-5.195-5.188-13.37-2.888-24.298 c5.647-26.698,21.829-28.774,26.654-28.774c5.112,0,9.528,1.979,12.435,5.574c4.225,5.226,5.178,13.432,2.829,24.39 C550.496,256.364,535.626,259.157,529.49,259.157z M539.404,212.436c-7.29,0-10.99,9.828-12.811,18.072 c-1.55,7.363-1.345,12.946,0.567,15.304c0.795,0.979,1.94,1.435,3.605,1.435c7.854,0,11.394-11.243,12.804-17.945 c1.601-7.248,1.406-12.998-0.521-15.396C542.245,212.905,541.086,212.436,539.404,212.436z"
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "#F41650",
    x1: 519.719,
    y1: 198.292,
    x2: 512.469,
    y2: 272.26
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "#EA1859",
    x1: 80.486,
    y1: 182.517,
    x2: 61.069,
    y2: 261.848
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "#EA1859",
    x1: 90.802,
    y1: 184.229,
    x2: 70.978,
    y2: 262.749
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    fill: "#EA1859",
    x1: 118.657,
    y1: 183.739,
    x2: 104.282,
    y2: 262.749
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    fill: "#EA1859",
    x1: 107.532,
    y1: 183.739,
    x2: 94.219,
    y2: 262.749
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovimemoLogo);
export default __webpack_public_path__ + "static/media/movimemo_logo.5dafd7967dd06e678bd3ac6f37eb58a0.svg";
export { ForwardRef as ReactComponent };